// extracted by mini-css-extract-plugin
module.exports = {"main":"_3G0r1JAwCs7NXH8nmLYzQZ"};